import styles from './index.module.css'
import { useShortlistUpload } from '@disco/services/upload/hooks'
import { sendMixpanelEvent } from '@disco/state-management/actions/AnalyticsActions'

import React, { useCallback } from 'react'
import { useDispatch } from 'hooks/use-redux'
import { useNavigate } from 'react-router-dom'
import type { UploadProvider } from 'types/upload'
import UploadOptions from 'components/common/upload/upload-options'
import DocumentHeadTags from 'components/document-head-tags'
import DiscoModal from 'components/ui/disco-modal'
import Heading from 'components/ui/heading'
const title = 'Import files'
export default function FileImportPage(): React.ReactNode {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  // No completion callback as we exit the modal on Pick
  const { uploadFiles } = useShortlistUpload()
  const close = useCallback(() => navigate('/'), [navigate])

  const onFilesSelect = (files: any[], provider: UploadProvider) => {
    dispatch(sendMixpanelEvent(`Browse - Import from ${provider.title}`))
    uploadFiles(files, provider, {
      title: 'Browse Upload',
      temporary: true,
      uploadCompletionTask: {
        type: 'show_tracks',
      },
      context: 'browse',
    })
    close()
  }

  return (
    <DiscoModal
      className="UploadOptions_Wrapper"
      onRequestClose={close}
      showCloseButton
    >
      <DocumentHeadTags title={`${title} | DISCO`} />
      <Heading size={600}>{title}</Heading>
      <div className={styles.UploadOptions_Wrapper}>
        <UploadOptions onPickedFiles={onFilesSelect} />
      </div>
    </DiscoModal>
  )
}
